// extracted by mini-css-extract-plugin
module.exports = {"courses_filters_group":"styles_courses_filters_group__m4XL8","courses_filters_group__search":"styles_courses_filters_group__search__Y4ypZ"};